<template>
  <v-dialog v-model="dialog" persistent max-width="70%" scrollable>
    <v-card>
      <v-card-title
        class="flex-column align-start
"
      >
        <span class="headline">
          Vincular {{ dadosColab.colaborador | TitleCase }} a Departamentos:
        </span>
        <v-row>
          <v-col cols="12" md="6">
            <BaseSelect
              prepend-inner-icon="mdi-file-table-box-multiple-outline"
              clearable
              single-line
              label="Segmento"
              item-text="descricao"
              item-value="id_band"
              service="sistemaService.tipoBandeiras"
              v-model="form.id_band"
              :isCompany="true"
              @change="vinculo()"
            />
          </v-col>
          <v-col cols="12" md="6">
            <BaseSelect
              prepend-inner-icon="mdi-domain"
              clearable
              single-line
              label="Empresa"
              item-text="apelido"
              item-value="id_empresa"
              service="sistemaService.empresa"
              :filters="{
                id_band: form.id_band
              }"
              v-model="form.id_empresa"
              :isCompany="true"
              @change="vinculo()"
            />
          </v-col>
        </v-row>
        <v-alert
          dense
          text
          :icon="false"
          type="warning"
          v-if="!form.id_empresa"
        >
          <v-icon class="mr-2" color="warning">mdi-alert-circle</v-icon>
          Selecione um segmento e uma empresa para visualizar o conteúdo
        </v-alert>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <h4 class="mb-2">
              <v-icon class="mr-1" color="red">mdi-close</v-icon>Departamentos
              não Vinculados
            </h4>
            <v-btn
              class="mb-3"
              color="success"
              @click="addTodos()"
              :disabled="naoVinculados.length == 0"
            >
              Adicionar todas
            </v-btn>
            <draggable
              handle=".handle"
              class="draggable-area exclude-companies"
              :list="naoVinculados"
              group="equipes"
              @change="moveAdded()"
            >
              <div
                class="v-list-item__content list"
                v-for="depto in naoVinculados"
                :key="depto.id_depto"
              >
                <div class="list-equipe-items">
                  <div>
                    <div class="d-flex align-center">
                      <strong class="mr-1">{{ depto.departamento }}</strong>
                    </div>
                  </div>
                  <div class="mr-4">
                    <v-btn icon @click="add(depto)">
                      <v-icon color="green">mdi-arrow-right-bold</v-icon>
                    </v-btn>
                  </div>
                </div>
              </div>
            </draggable>
          </v-col>

          <v-divider vertical></v-divider>

          <v-col>
            <h4 class="mb-2">
              <v-icon class="mr-1" color="green">mdi-check</v-icon>Departamentos
              Vinculados
            </h4>
            <v-btn
              class="mb-3"
              color="error"
              @click="removerTodos()"
              :disabled="vinculados.length == 0"
            >
              Remover todas
            </v-btn>
            <draggable
              handle=".handle"
              class="draggable-area include-companies"
              :list="vinculados"
              group="equipes"
              @change="moveRemove()"
            >
              <div
                class="v-list-item__content"
                v-for="depto in vinculados"
                :key="depto.id_depto"
              >
                <div class="list-equipe-participantes-items">
                  <div>
                    <v-btn class="mr-4" icon @click="remover(depto)">
                      <v-icon color="red">mdi-arrow-left-bold</v-icon>
                    </v-btn>
                  </div>
                  <div class="list-equipe mr-4">
                    <div class="d-flex align-center">
                      <strong class="mr-1">{{ depto.departamento }}</strong>

                      <!-- - {{ empresa.nome }} -->
                    </div>
                  </div>
                </div>
              </div>
            </draggable>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="close()">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import draggable from "vuedraggable";
import BaseSelect from "@/components/shared/BaseSelectService";
import sistema from "@/services/http/sistemaService";
import comissao from "@/services/http/comissaoService";

export default {
  name: "DraggableColabMultDepto",

  components: {
    draggable,
    BaseSelect
  },

  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    dadosColab: {
      type: Object
    }
  },

  data() {
    return {
      form: {
        id_band: "",
        id_empresa: ""
      },
      naoVinculados: [],
      vinculados: []
    };
  },

  watch: {
    dialog(value) {
      this.default();
      return value;
    }
  },

  methods: {
    async vinculo() {
      //let colabEmp = await this.fetchColabEmpresa();

      this.vinculados = await this.fetchColabDepartamentos();
      this.naoVinculados = await this.fetchDepartamentos();
      let idVinculados = this.vinculados.map(item => item.id_depto);

      this.naoVinculados = this.naoVinculados.filter(
        item => !idVinculados.includes(item.id_depto.toString())
      );
    },

    async fetchColabDepartamentos() {
      //if (!this.form.id_empresa) return [];
      let { data } = await sistema()
        .colaboradoresDepartamentos()
        .show({
          per_page: -1,
          id_colaborador: this.dadosColab.id_colaborador,
          id_empresa: this.form.id_empresa
        });
      return data.data;
    },

    async fetchDepartamentos() {
      let { data } = await comissao()
        .departamentos()
        .show({ per_page: -1 });
      return data.data;
    },

    async addTodos() {
      try {
        let allPost = this.naoVinculados.map(item => {
          const form = {
            id_colaborador: this.dadosColab.id_colaborador,
            id_empresa: this.form.id_empresa,
            id_band: this.form.id_band,
            id_depto: item.id_depto
          };

          return sistema()
            .colaboradoresDepartamentos()
            .store(form, {
              notification: true,
              message: "Colaborador vinculado com sucesso!"
            });
        });

        await Promise.all(allPost);
      } catch (error) {
        // console.log(error);
        this.$notify({
          type: "error",
          text: `Erro ao adicionar empresa`
        });
      } finally {
        this.vinculo();
      }
    },
    async removerTodos() {
      try {
        let allDelete = this.vinculados.map(item => {
          return sistema()
            .colaboradoresDepartamentos(item.id_colaborador_departamento)
            .delete(
              {},
              { notification: true, message: "Empresa removida com sucesso!" }
            );
        });
        await Promise.all(allDelete);
      } catch (error) {
        this.$notify({
          type: "error",
          text: `${error.response.data.message}` || `Erro ao remover empresa`
        });
      } finally {
        this.vinculo();
      }
    },

    async add(item) {
      try {
        const form = {
          id_colaborador: this.dadosColab.id_colaborador,
          id_empresa: this.form.id_empresa,
          id_band: this.form.id_band,
          id_depto: item.id_depto
        };
        await sistema()
          .colaboradoresDepartamentos()
          .store(form, {
            notification: true,
            message: "Departamento vinculado com sucesso!"
          });
      } catch (error) {
        this.$notify({
          type: "error",
          text: ` Erro ao adicionar  `
        });
      } finally {
        this.vinculo();
      }
    },

    async remover(item) {
      try {
        await sistema()
          .colaboradoresDepartamentos(item.id_colaborador_departamento)
          .delete(
            {},
            {
              notification: true,
              message: "Departamento removido com sucesso!"
            }
          );
      } catch (error) {
        this.$notify({
          type: "error",
          text:
            `${error.response.data.message}` || `Erro ao remover departamento`
        });
      } finally {
        this.vinculo();
      }
    },

    moveAdded(evt) {
      let empresa = {};
      const { removed } = evt;

      if (removed) {
        empresa = removed.element;
        this.add(empresa);
      }
    },

    moveRemove(evt) {
      let empresa = {};
      const { removed } = evt;

      if (removed) {
        empresa = removed.element;
        this.remover(empresa);
      }
    },

    close() {
      this.$emit("close");
    },

    default() {
      this.form.id_band = "";
      this.form.id_empresa = "";
      this.naoVinculados = [];
      this.vinculados = [];
    }
  }
};
</script>

<style scoped>
.v-list-item__content {
  padding-inline-start: 15px;
  border: 1px solid hsla(0, 0%, 31%, 0.199);
  border-radius: 10px;
  margin-bottom: 4px;
}

.draggable-area {
  min-height: 300px;
  padding: 8px;
}

.draggable-area.include-companies {
  border: 2px dashed hsla(128, 100%, 34%, 0.39);
}

.draggable-area.exclude-companies {
  border: 2px dashed hsla(347, 100%, 34%, 0.39);
}
.v-list-item__content .list {
  display: flex !important;
  justify-content: space-between;
}

.list-equipe-items {
  display: flex !important;
  justify-content: space-between;
}

.list-equipe-participantes-items {
  display: flex !important;
}

.list-equipe {
  display: flex !important;
  flex-direction: column;
}
</style>
